import { cn } from "@/lib/utils"
import { cva, VariantProps } from "class-variance-authority"
import React from "react"

const labelVariants = cva("h-label", {
  variants: {
    fullWidth: {
      true: "h-label--block",
    },
  },
})

const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement> & VariantProps<typeof labelVariants>
>(({ className, children, fullWidth, ...props }, ref) => (
  <label ref={ref} className={cn(labelVariants({ fullWidth }), className)} {...props}>
    {children}
  </label>
))
Label.displayName = "Label"

export { Label }
